module.exports = __webpack_public_path__ + "img/valkirias.2068f7df.png";